"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inferSchema = void 0;
const utils_1 = require("./utils");
const inferSchema = (dataFragment) => {
    if ((0, utils_1.isRef)(dataFragment)) {
        return dataFragment;
    }
    if (!(0, utils_1.isObjectLike)(dataFragment)) {
        return utils_1.EMPTY_SCHEMA;
    }
    let schema;
    (0, utils_1.traverse)(dataFragment, (value, path) => {
        if (Array.isArray(value)) {
            schema = schema || {};
            (0, utils_1.setByArray)(schema, path, []);
            return false;
        }
        if ((0, utils_1.isRef)(value)) {
            schema = schema || {};
            (0, utils_1.setByArray)(schema, path, value);
            return true;
        }
    }, utils_1.SMALL_FACTOR);
    return schema;
};
exports.inferSchema = inferSchema;
//# sourceMappingURL=inferSchema.js.map